import React from 'react';
import { View } from 'react-native';

import ThemeStyle from '../../Theme/styles';

import { ids, styles } from './styles';

type Props = {
  fullWidth: boolean;
};

const ListContent = ({
  children,
  fullWidth,
}: React.PropsWithChildren<Props>) => {
  return (
    <View
      dataSet={{ media: ids.contentWrapper }}
      style={[
        ThemeStyle.flex1,
        ThemeStyle.flexDirectionRow,
        styles.contentWrapper,
        fullWidth ? styles.fullWidthWrapper : styles.maxWidthWrapper,
      ]}
    >
      {children}
    </View>
  );
};

export default ListContent;
